"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterResponse = filterResponse;
/**
 * Filters all results in a V3Response to those that match the given model and operation, and returns the data as an
 * array.
 * @param res The response to filter.
 * @param model The model to filter for.
 * @param operation The operation to filter for.
 * @returns An array of the data that matches the given model and operation.
 */

function filterResponse(res, model, operation) {
  let result;
  if ('result' in res) {
    result = res.result;
  } else {
    result = res;
  }

  // Normally, "implicit type predicates" would narrow the type to the correct type, but I guess it doesn't work in this
  // case.
  return result.filter(item => item.model === model && item.operation === operation).flatMap(item => item.data);
}